import * as React from 'react'

import { mkassaApi } from 'redux/services/mkassa'
import { GetMkassaParams } from 'redux/services/mkassa/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { COMMON_STATUS_TEXT } from 'constants/common'
import { Mkassa } from 'models/mkassa'

import { formatDate } from 'shared/libs'
import { EmptyDetails } from 'shared/ui'

import { Details } from './components/Details'
import { Filters } from './components/Filters'
import Statistics from './components/Statistics'

export const MkassaPage = () => {
  const [selectedRowId, setSelectedRowId] = React.useState<
    Mkassa['id'] | undefined
  >()
  const [filters, setFilters] = React.useState<GetMkassaParams>({
    limit: 10,
    offset: 0,
  })
  const [fetch, fetchState] = mkassaApi.useLazyGetMkassaQuery()

  React.useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const onChangeFilters = (newFilters: GetMkassaParams) => {
    newFilters.limit = filters.limit
    newFilters.offset = filters.offset
    setFilters(newFilters)
  }

  return (
    <>
      <AppLayoutTable
        title="Мкасса"
        header={
          <Filters fetching={fetchState.isLoading} onSubmit={onChangeFilters} />
        }
        statistics={<Statistics filters={filters} />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID',
                  key: 'id',
                  width: 100,
                },
                {
                  data: 'Название',
                  key: 'name',
                  width: 50,
                },
                {
                  data: 'Дата создания',
                  key: 'created_at',
                  width: 50,
                  render: (_, item) => formatDate(item.created_at),
                },
                {
                  data: 'JIRA',
                  key: 'jira_key',
                  width: 50,
                },
                {
                  data: 'Статус',
                  key: 'status',
                  width: 50,
                  render: (_, item) => COMMON_STATUS_TEXT[item.status],
                },
                {
                  data: 'QR',
                  key: 'count_qr',
                  width: 50,
                },
              ]}
            />

            <AppPagination
              forcePage={filters.offset! / filters.limit!}
              onPageChange={nextPage => {
                setFilters({
                  ...filters,
                  offset: (nextPage - 1) * filters.limit!,
                })
              }}
              count={fetchState.data.count / filters.limit!}
            />
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
